(function () {
  var DURATION = 350;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resetPanel(panel) {
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  }

  function collapsePanel(details) {
    var panel = details.querySelector('.oleum-aprender-cat__panel');
    if (!panel || !details.open) return Promise.resolve();

    if (prefersReducedMotion()) {
      details.open = false;
      return Promise.resolve();
    }

    var start = panel.scrollHeight;
    panel.style.height = start + 'px';
    panel.style.overflow = 'hidden';
    panel.style.transition = 'height ' + DURATION + 'ms ease';

    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        details.open = false;
        resetPanel(panel);
        resolve();
      }

      panel.addEventListener('transitionend', onEnd);
    });
  }

  function expandPanel(details) {
    var panel = details.querySelector('.oleum-aprender-cat__panel');
    if (!panel) return Promise.resolve();

    if (prefersReducedMotion()) {
      details.open = true;
      return Promise.resolve();
    }

    details.open = true;
    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
    panel.style.transition = 'height ' + DURATION + 'ms ease';
    var end = panel.scrollHeight;

    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        panel.style.height = end + 'px';
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        resetPanel(panel);
        resolve();
      }

      panel.addEventListener('transitionend', onEnd);
    });
  }

  function init(root) {
    if (!root || root.dataset.oleumAprenderCatInit === '1') return;
    root.dataset.oleumAprenderCatInit = '1';

    var items = root.querySelectorAll('details.oleum-aprender-cat__accordion');

    items.forEach(function (details) {
      var summary = details.querySelector('.oleum-aprender-cat__summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        var willOpen = !details.open;

        if (prefersReducedMotion()) {
          if (willOpen) {
            items.forEach(function (other) {
              if (other !== details) other.open = false;
            });
            details.open = true;
          } else {
            details.open = false;
          }
          return;
        }

        if (willOpen) {
          var closes = [];
          items.forEach(function (other) {
            if (other !== details && other.open) {
              closes.push(collapsePanel(other));
            }
          });
          Promise.all(closes).then(function () {
            expandPanel(details);
          });
        } else {
          collapsePanel(details);
        }
      });
    });
  }

  document.querySelectorAll('[data-oleum-aprender-categories]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-oleum-aprender-categories]');
    if (root) init(root);
  });
})();
